import { render, staticRenderFns } from "./UserBlacklist.vue?vue&type=template&id=7c0f9330&"
import script from "./UserBlacklist.vue?vue&type=script&lang=js&"
export * from "./UserBlacklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports